import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { ChatHeader, ChatLogModel } from '../models/chat.model';
import { GetTranslationService } from './get-translation.service';
import { ModalMakerService } from './modal-maker.service';
import { ToastMachineService } from './toast-machine.service';
import { HotSupportChatStatus } from '../models/hot-support-chat-status';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  chatHeaders: ChatHeader[] =
    JSON.parse(localStorage.getItem('chatHistory')) || [];
  badge = 0;

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
    private translator: GetTranslationService,
    private modalServ: ModalMakerService
  ) {}

  getHeaders() {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.apiURL + '/chatheaders?' + new Date().getTime())
        .subscribe({
          next: async (resp: ChatHeader[]) => {
            if (resp) {
              const LASTBADGE = this.badge;
              this.badge = 0;

              resp = resp.sort(
                (a, b) =>
                  new Date(b.last_time).getTime() -
                  new Date(a.last_time).getTime()
              );
              resp.forEach((chat) => {
                this.badge += chat.badge;
              });

              if (this.badge > LASTBADGE) {
                const MSG = await this.translator.getTranslate(
                  'You have a new message!'
                );
                this.toaster.toastMachine(MSG, 'primary', 5000, [
                  {
                    text: await this.translator.getTranslate('View'),
                    side: 'end',
                    handler: () => {
                      this.modalServ.openChat(resp[0], false);
                    },
                  },
                ]);
              }
            }

            this.chatHeaders = resp;
            localStorage.setItem('chatHistory', JSON.stringify(resp));

            resolve(this.chatHeaders);
          },

          error: (err) => {
            reject(err);
          },
        });
    });
  }

  async getHistory() {
    if (!this.chatHeaders || this.chatHeaders.length === 0) {
      await this.getHeaders();
    }
    return this.chatHeaders;
  }

  // api.POST("/profiles/:id/chat_status", apicontrollers.POSTHotSupportChatStatus) // Profilin chat statusunu aktif ya fa pasif olduğunu anlamak için kullanılır.

  postChatStatus(
    profileid: number,
    hotsupportchatstatus: HotSupportChatStatus
  ): Promise<HotSupportChatStatus> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          environment.apiURL + '/profiles/' + profileid + '/chat_status',
          hotsupportchatstatus
        )
        .subscribe({
          next: (resp: HotSupportChatStatus) => {
            resolve(resp);
          },
          error: (err) => {
            reject(err);
          },
        });
    });
  }

  getChatLog(id: number): Promise<ChatLogModel[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.apiURL + '/request/' + id + '/chatrecords')
        .subscribe({
          next: (resp: ChatLogModel[]) => {
            resolve(resp);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  postChatMessage(data: ChatLogModel) {
    return new Promise((resolve, reject) => {
      this.http
        .post(environment.apiURL + '/request/chatrecords', data)
        .subscribe({
          next: (resp) => {
            resolve(resp);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  getLiveSupportLog(profileId: number): Promise<ChatLogModel[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.apiURL + '/profiles/' + profileId + '/chat_log')
        .subscribe({
          next: (resp: ChatLogModel[]) => {
            resolve(resp);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  postLiveSupportMessage(profileId: number, data: ChatLogModel) {
    return new Promise((resolve, reject) => {
      data.record_type = 'HotSupport';
      this.http
        .post(environment.apiURL + '/profiles/' + profileId + '/chat_log', data)
        .subscribe({
          next: (resp) => {
            resolve(resp);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }
}
